// Keeps the open tab of a page in the URL (?tab=1), as the big site does: back / forward returns to the
// same tab, and a shared or reloaded link opens on it. The page binds its v-tabs to `tab`.
function parseTab(value) {
    const tab = Number.parseInt(value, 10)
    return Number.isNaN(tab) || tab < 0 ? 0 : tab
}

export default {
    watch: {
        // back / forward (or a link with ?tab) changes the query: follow it
        '$route.query.tab': {
            handler(value) {
                const routeTab = parseTab(value)
                if (this.tab !== routeTab) {
                    this.tab = routeTab
                }
            },
            immediate: true
        },
        // a click on a tab: write it in the URL without a new history entry
        tab(value) {
            if (value === null || value === undefined) {
                return
            }
            const current = this.$route.query.tab
            if ((current === undefined && value === 0) || parseTab(current) === value) {
                return
            }
            const query = { ...this.$route.query, tab: String(value) }
            if (value === 0) {
                delete query.tab
            }
            this.$router.replace({ query }).catch(() => {})
        }
    }
}
